<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import ApiService from "@/services/jobsiteTrackingService";
import FilesModal from "@/components/modals/filesModal";
import PageHeader from "@/components/page-header";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import WorkOrderCard from "@/components/WorkOrderCard";
import PackingCard from "@/components/PackingCard";
import PackingListFilter from "@/components/PackingListFilter";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    FilesModal,
    Loading,
    PageHeader,
    WorkOrderCard,
    PackingCard,
    PackingListFilter,
  },
  data() {
    return {
      items: null,
      isLoading: false,
      chartOptions: {
        chart: {
          height: 90,
          type: "radialBar",
          sparkline: {
            enabled: true,
          },
          offsetX: -20,
        },
        colors: ["#34c38f"],
        plotOptions: {
          radialBar: {
            startAngle: 0,
            endAngle: 360,
            track: {
              background: "#f8f9fa",
              strokeWidth: "97%",
              margin: 5, // margin is in pixels
            },
            hollow: {
              size: "24%",
            },

            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: 5,
                fontSize: "12px",
              },
            },
          },
        },
        grid: {
          padding: {
            top: 0,
          },
        },
        stroke: {
          dashArray: 0,
        },
        labels: ["Storage"],
      },
      searchText: "",
      filter: "",
      sort: "deliveryDate",
      sortDirection: "asc",
      pagesize: 18,
      totalRows: 0,
      showCompleted: false,
      selectedView: "withpacking",
      selectedShipper: null,
      selectedInstaller: null,
    };
  },
  mounted() {},
  methods: {
    getData() {
      this.isLoading = true;
      var request = {
        page: 1,
        pageSize: this.pagesize,
        search: this.filter,
        sortBy: this.sort,
        sortDesc: this.sortDirection == "desc",
        completed: this.showCompleted,
      };
      var promise =
        this.selectedView === "withpacking"
          ? ApiService.getPackings(request)
          : ApiService.getWorkOrders(request);
      return promise
        .then((response) => {
          this.items = response.data.items;
          this.totalRows = response.data.totalCount;
        })
        .catch((error) => {
          window.console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    setSortDeliveryDate() {
      if (this.sort == "deliveryDate" && this.sortDirection == "asc") {
        if (this.sortDirection == "asc") {
          this.sortDirection = "desc";
        } else {
          this.sortDirection = "asc";
        }
      } else {
        this.sort = "deliveryDate";
        this.sortDirection = "asc";
      }
    },
    setSortInstallationDate() {
      if (this.sort == "installationDate" && this.sortDirection == "asc") {
        if (this.sortDirection == "asc") {
          this.sortDirection = "desc";
        } else {
          this.sortDirection = "asc";
        }
      } else {
        this.sort = "installationDate";
        this.sortDirection = "asc";
      }
    },
    openFilesModal(workOrder) {
      this.$refs.filesModal.openEventDialog(workOrder);
    },
    reload(e) {
      if (e == "/") {
        this.getData();
      }
    },
    loadMore() {
      this.pagesize = this.pagesize + 9;
      this.getData();
    },
  },
  computed: {
    installers() {
      var listInstallers = [].concat.apply(
        [],
        [].concat
          .apply(
            [],
            this.packings?.map((x) => x.workOrderPackingInfoResources),
          )
          .map((x) => x.installers),
      );
      return [...new Set(listInstallers.map((s) => s.key))]
        .map((x) => {
          return {
            value: x,
            text: listInstallers.find((s) => s.key === x).value,
          };
        })
        .concat([
          { value: null, text: this.$t("general.nofilter") },
          { value: "0", text: this.$t("general.noinstaller") },
        ])
        .sort((a, b) =>
          a.value == null
            ? -1
            : b.value == null
            ? 1
            : a.value.localeCompare(b.value),
        );
    },
    shippers() {
      var listShippers = [].concat
        .apply(
          [],
          this.packings?.map((x) => x.workOrderPackingInfoResources),
        )
        .filter((x) => x.shipper != null)
        .map((x) => x.shipper);
      return [...new Set(listShippers.map((s) => s.key))]
        .map((x) => {
          return {
            value: x,
            text: listShippers.find((s) => s.key === x).value,
          };
        })
        .concat([
          { value: null, text: this.$t("general.nofilter") },
          { value: "0", text: this.$t("general.noshipper") },
        ])
        .sort((a, b) =>
          a.value == null
            ? -1
            : b.value == null
            ? 1
            : a.value.localeCompare(b.value),
        );
    },
    viewOptions() {
      return [
        {
          value: "withpacking",
          text: this.$t("general.withpacking"),
        },
        {
          value: "nopacking",
          text: this.$t("general.nopacking"),
        },
      ];
    },
  },
  watch: {
    selectedView() {
      this.items = [];
      this.getData();
    },
    searchText() {
      if (typeof window.LIT !== "undefined") {
        clearTimeout(window.LIT);
      }
      window.LIT = setTimeout(() => {
        this.filter = this.searchText;
        this.getData();
      }, 500);
    },
    sort() {
      this.getData();
    },
    sortDirection() {
      this.getData();
    },
    showCompleted() {
      this.getData();
    },
  },
  created() {
    this.getData();
  },
};
</script>

<template>
  <Layout @reload="reload">
    <PageHeader :title="$t('general.mypackinglist')" />
    <div class="my-1 card">
      <div class="card-body p-2">
        <div class="d-flex flex-column justify-content-start">
          <div
            class="p-0 d-flex flex-row align-items-center justify-content-between"
          >
            <b-form-input
              id="searchText"
              v-model="searchText"
              :placeholder="$t('general.search')"
              class="m-1"
              style="flex: 1"
            />
            <b-button
              class="d-flex flex-row align-items-center d-md-none"
              v-b-toggle.collapse-1
              variant="outline-primary"
            >
              <i class="mdi mdi-filter-variant"></i>
            </b-button>
            <PackingListFilter
              class="flex-fill justify-content-between d-none d-md-flex"
              :sort="sort"
              :sort-direction="sortDirection"
              :shippers="shippers"
              :selected-shipper.sync="selectedShipper"
              :installers="installers"
              :selected-installer.sync="selectedInstaller"
              :show-completed.sync="showCompleted"
              :selected-view.sync="selectedView"
              :view-options="viewOptions"
              @sort-delivery-date="setSortDeliveryDate"
              @sort-installation-date="setSortInstallationDate"
            />
          </div>
          <b-collapse id="collapse-1" class="mt-1" lazy>
            <PackingListFilter
              :sort="sort"
              :sort-direction="sortDirection"
              :shippers="shippers"
              :selected-shipper.sync="selectedShipper"
              :installers="installers"
              :selected-installer.sync="selectedInstaller"
              :show-completed.sync="showCompleted"
              :selected-view.sync="selectedView"
              :view-options="viewOptions"
              @sort-delivery-date="setSortDeliveryDate"
              @sort-installation-date="setSortInstallationDate"
            />
          </b-collapse>
        </div>
      </div>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>
    <div
      class="align-items-stretch d-flex flex-row flex-wrap justify-content-start"
      style="gap:.5rem;  min-height: 0; position: relative"
    >
      <template v-if="selectedView == 'nopacking'">
        <div
          style="flex-basis: 420px;"
          v-for="(workOrder, index) in items"
          :key="'nopacking' + index"
        >
          <div class="card border">
            <WorkOrderCard
              :workOrder="workOrder"
              @open-files="openFilesModal"
            />
          </div>
        </div>
      </template>
      <template v-if="selectedView == 'withpacking'">
        <div
          style="flex-basis: 420px;"
          v-for="(packing, index) in items"
          :key="'withpacking' + index"
        >
          <PackingCard :packing="packing" @open-files="openFilesModal" />
        </div>
      </template>
    </div>
    <div class="w-100">
      <div class="p-2 border-top" v-show="items && totalRows != items.length">
        <a class="btn btn-sm btn-light btn-block text-center" @click="loadMore">
          <i class="mdi mdi-arrow-down-circle mr-1"></i>
          {{ $t("navbar.dropdown.notification.button") }}
        </a>
      </div>
    </div>
    <FilesModal ref="filesModal" />
  </Layout>
</template>
<style scoped>
@media (max-width: 450px) {
  .card {
    margin-bottom: 0.5rem;
  }
}
</style>
